import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { GroupEffects } from './member-group.effects';
import { memberGroupReducer } from './member-group.reducer';

export const provideMemberGroupStore = () => [
  provideState('memberGroups', memberGroupReducer),
  provideEffects([GroupEffects]),
];
